import { connect } from 'react-redux'
import View from './index'
import {stdAction, ACTIONS} from '../../actions/Actions'

const mapStateToProps = (state, ownProps) => {

  return {
	  company: state.companies.opened
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {

  return {
	  uploadError: (errors) => dispatch({type: ACTIONS.reports.create().statuses.error, data: errors}),
	  getCompany: (id) => dispatch(stdAction(ACTIONS.companies.show(id))),
	  createReport: (company_id, report_type, options={}) => dispatch(stdAction(ACTIONS.reports.create(company_id), {report_type: report_type, ...{options: options}}, () => dispatch(stdAction(ACTIONS.users.current)))),
	  updateReport: (id) => dispatch(stdAction(ACTIONS.reports.update(id), {}, () => dispatch(stdAction(ACTIONS.users.current)))),
  }
}

const Container = connect(
  mapStateToProps,
  mapDispatchToProps
)(View)



export default Container
